import { apiGet } from '~/utils/api'
import type { TradeInLocation } from '~/utils/tradeInFulfillment'

export function useTradeInReceivingAPI() {
  const resolvingMailLocation = ref(false)
  const loadingDropOffLocations = ref(false)

  async function fetchMailLocation(): Promise<TradeInLocation> {
    resolvingMailLocation.value = true
    try {
      const location = await apiGet<TradeInLocation>('/api/app/v1/trade-in/receiving-locations/mail')
      return {
        ...location,
        instructions: location.shippingInstructions ?? location.instructions,
      }
    } finally {
      resolvingMailLocation.value = false
    }
  }

  async function fetchDropOffLocations(): Promise<TradeInLocation[]> {
    loadingDropOffLocations.value = true
    try {
      const locations = await apiGet<TradeInLocation[]>('/api/app/v1/trade-in/receiving-locations?shippingOption=DROP_OFF')
      return locations.map(location => ({
        ...location,
        instructions: location.shippingInstructions ?? location.instructions,
      }))
    } finally {
      loadingDropOffLocations.value = false
    }
  }

  return {
    resolvingMailLocation,
    loadingDropOffLocations,
    fetchMailLocation,
    fetchDropOffLocations,
  }
}
